import { RESET_COMPARISON_SUCCESS } from '../Comparator/Comparator.actions'
import {
  COMPARATOR_TRADED_AMOUNTS,
  COMPARATOR_TRADED_AMOUNTS_SUCCESS,
  COMPARATOR_TRADED_AMOUNTS_ERROR
} from './ComparatorTradedAmounts.actions'

const initialState = {
  data: { chartStructure: [], csvStructure: [], categories: [] },
  fetching: false,
  fetched: false,
  error: null
}

/**
 * Comparator Traded Amount's reducer.
 */
const comparatorTradedAmountReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case COMPARATOR_TRADED_AMOUNTS: {
      return { ...state, fetching: true }
    }
    case COMPARATOR_TRADED_AMOUNTS_SUCCESS: {
      return { ...state, data: payload, fetching: false, fetched: true }
    }
    case COMPARATOR_TRADED_AMOUNTS_ERROR: {
      return { ...state, error: payload.error }
    }
    case RESET_COMPARISON_SUCCESS: {
      return initialState
    }
    default: {
      return state
    }
  }
}

export default comparatorTradedAmountReducer
